<template lang="pug">
  v-menu(
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x)
    template(v-slot:activator="{ on }")
      v-btn(v-on="on") Dev Menu
    v-layout(column)
      v-text-field(
        v-model="privateChatId",
        solo,
        label="Private chat",
        placeholder="Private chat",
        hint="Реальный ID юзера",
        persistent-hint,
        outlined)
      v-text-field(
        v-model="groupChatIds",
        solo,
        label="Group chat",
        placeholder="Group chat",
        hint="Перечислить 2 и более ID юзеров через запятую",
        persistent-hint,
        outlined)
      v-text-field(
        v-model="groupChatTitle",
        solo,
        label="Title",
        placeholder="Group chat title",
        hint="Название группового чата",
        persistent-hint,
        outlined)
      v-btn(:text="true", @click="createChats") Create
      v-text-field(
        v-model="joinChatId",
        solo,
        label="Title",
        placeholder="ID чата для входа",
        hint="ID существующего чата",
        persistent-hint,
        outlined)
      v-btn(:text="true", @click="onJoinChatClick") Join
      v-text-field(
        v-model="rawRequest",
        solo,
        label="Raw request",
        placeholder="JSON format",
        hint="Строка вида [\"message-referral\", {\"nickname\": \"refferal1\"}]",
        persistent-hint,
        outlined)
      v-btn(:text="true", @click="sendRawRequest") Send
      v-text-field(
        v-model="messagesRange",
        solo,
        label="Отправить сообщения в чат в диапазоне с 1 по 100",
        placeholder="179, 1-100",
        hint="chat_id, from-to",
        persistent-hint,
        outlined)
      v-btn(:text="true", @click="sendMessageInLoop") Send
</template>

<script>
import socket from '@/socket';

export default {
  data() {
    return {
      menu: false,
      privateChatId: '',
      groupChatIds: '',
      groupChatTitle: '',
      joinChatId: '',
      rawRequest: '',
      messagesRange: ''
    };
  },
  methods: {
    createChats() {
      const privateIds = this.privateChatId.match(/\d+/g);
      const groupIds = this.groupChatIds.match(/\d+/g);

      if (privateIds && privateIds.length) {
        socket.emit('create-private-chat', { user_id: +privateIds[0] }, () => { this.menu = false; });
      }

      if (groupIds && groupIds.length) {
        const users = groupIds.map(id => ({ id: +id }));
        const title = this.groupChatTitle || `Group chat: users ${this.authUser.id}, ${groupIds.join(', ')}`;

        this.createGroupChat({ title, users });
      }
    },
    onJoinChatClick() {
      const chatId = parseInt(this.joinChatId, 10);

      if (chatId) this.joinChat(chatId);
    },
    joinChat(chatId) {
      const request = {
        type: 'join-chat',
        payload: { chat_id: chatId }
      };

      socket.emit(request.type, request.payload, () => { this.menu = false; });
    },
    sendRawRequest() {
      if (!this.rawRequest) return;

      try {
        const arr = JSON.parse(this.rawRequest);
        socket.emit(arr[0], arr[1], () => { this.menu = false; });
        this.rawRequest = '';
      } catch (e) {
        console.error(e);
      }
    },
    createGroupChat(payload) {
      const request = {
        type: 'create-group-chat',
        payload
      };

      socket.emit(request.type, request.payload, () => { this.menu = false; });
    },
    sendMessageInLoop() {
      const arr = this.messagesRange.split(',');
      const range = arr[1].split('-');

      for (let i = parseInt(range[0], 10); i <= parseInt(range[1], 10); i++) {
        const request = {
          type: 'message',
          payload: { chat_id: Number(arr[0]), message: i.toString() }
        };

        socket.emit(request.type, request.payload);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .v-menu__content { background: $white; }

</style>
